export default "__VITE_ASSET__UbhbQ4cH__"